import { useEffect, useState } from "react";
import { useTranslation } from "../hooks/useTranslation";
import { PartnerApi } from "../api/partner.api";
import { useBreadcrumbsStore } from "../store/breadcrumbs.store";
import { useAuthStore } from "../store/auth.store";
import { useSoldSNStore } from "../store/soldsn.store";
import { useLetters } from "../hook/partner/soldsnletters.partner.hook";
import { Nav } from "react-bootstrap";
import SoldSNCompanies from "../components/SoldSN/SoldSNCompanies";
import SoldSNSearch from "../components/modals/soldsn/SoldSNSearch";

function SoldSN() {
  const { t } = useTranslation();
  const token = useAuthStore((state) => state.token);
  const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
  const setPagename = useBreadcrumbsStore((state) => state.setPagename);

  const lettersMutation = useLetters();
  const letters = useSoldSNStore((state) => state.letters);
  const [letter, setLetter] = useState(null);
  const [searchSN, setSearchSN] = useState(false);

  useEffect(() => {
    setPagename(t("soldSn.soldSerialNumbers"));
    setBreadcrumbs([]);
  }, [t]);

  useEffect(() => {
    if (token) {
      lettersMutation.mutate({ token });
    }
  }, [token]);

  useEffect(() => {
    if (!letter && letters) {
      setLetter(letters[0]?.letter);
    }
  }, [letters]);

  if (lettersMutation.isLoading) {
    return <div className="alert alert-info">{t("common.loading")}...</div>;
  }

  return letters?.error ? (
    <div className="alert alert-danger">{letters.error}</div>
  ) : (
    <>
      <SoldSNSearch
        showModal={searchSN}
        doCloseModal={() => setSearchSN(false)}
      />
      <div className="btn-group mb-3" style={{ float: "right" }}>
        <button className="btn btn-primary" onClick={() => setSearchSN(true)}>
          {t("soldSn.searchedSn")}
        </button>
        <button
          className="btn btn-success"
          onClick={() =>
            PartnerApi.soldSNExport({
              token,
            })
          }
        >
          {t("common.exportXlsx")}
        </button>
      </div>
      <h3>{t("soldSn.soldSerialNumbers")}</h3>
      {letters?.length > 0 ? (
        <>
          <div className="card" style={{ clear: "both" }}>
            <div className="card-body">
              <div className="d-none d-lg-block">
                <Nav
                  activeKey={letter}
                  as="ul"
                  className="mb-5 nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold"
                >
                  {letters.map((l) => (
                    <Nav.Item as="li" key={l.letter}>
                      <Nav.Link
                        eventKey={l.letter}
                        onClick={() => setLetter(l.letter)}
                      >
                        {l.letter}
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
              </div>
              <div className="d-lg-none">
                <select
                  type="select"
                  className="form-control mb-2"
                  value={letter}
                  onChange={(e) => setLetter(e.target.value)}
                >
                  {letters.map((l) => (
                    <option value={l.letter} key={l.letter}>
                      {l.letter}
                    </option>
                  ))}
                </select>
              </div>
              {letter && <SoldSNCompanies letter={letter} />}
            </div>
          </div>
        </>
      ) : (
        <div className="alert alert-danger">{t("common.nothingFound")}</div>
      )}
    </>
  );
}

export default SoldSN;
